import styled from 'styled-components'
import { breakpoints, colors, fontFamily, fontWeight, typography } from 'theme'

export const Section = styled.div<{ width?: number | string }>(
  {
    overflow: 'hidden',
    color: colors.primary.medium,
    fontFamily: fontFamily.inter,
    fontSize: typography.semiXS.fontSize,
    fontWeight: fontWeight.bold,
    lineHeight: typography.semiXS.lineHeight,
    letterSpacing: '0em',
    textAlign: 'left',
    backgroundColor: colors.gray[450],
    padding: '24px',
    borderRadius: '8px',
    maxWidth: '1280px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '40px',
    // margin: '0 16px 0 16px',
    [`@media ${breakpoints.md}`]: {
      minWidth: '668px',
    },
    [`@media ${breakpoints.xs}`]: {
      width: '100%',
    },
    [`@media ${breakpoints.xxs}`]: {
      rowGap: '24px',
    },
  },
  ({ width }) => ({ width }),
)

export const SectionHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  rowGap: '24px',
  alignItems: 'center',
  [`@media ${breakpoints.xxs}`]: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'baseline',
  },
})

export const SectionTitle = styled.div({
  fontFamily: fontFamily.inter,
  fontSize: typography.semiXS.fontSize,
  fontWeight: fontWeight.bold,
  lineHeight: typography.semiXS.lineHeight,
  letterSpacing: '0em',
  textAlign: 'left',
  height: '23px',
  color: colors.primary.medium,
})
